import { Component, DOCUMENT, inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { setAppContext } from '@store/actions/context.actions';
import { AppContextModel } from '@store/models/context-model';
import { StorageUtilsService } from './services/storage-utils/storage-utils.service';
import { Store } from '@ngrx/store';
import { Constants } from '@core/constants/constants';
import { LanguagesService } from './layout/common/languages/languages.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { NgHttpLoaderComponent } from 'ng-http-loader';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet, NgHttpLoaderComponent],
})
export class AppComponent implements OnInit, OnDestroy {
    private _storageUtilsService = inject(StorageUtilsService);
    private _store = inject(Store);
    private renderer: Renderer2 = inject(Renderer2);
    private _languagesService = inject(LanguagesService);
    document = inject(DOCUMENT);
    private _unsubscribeAll = new Subject<void>();


    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
    ngOnInit(): void {
        this.setAppContextAndLanguageValue();
        this.languagesChangeListener();
    }

    /** set app context & lang */
    setAppContextAndLanguageValue(): void {
        /** set app context */
        const appContextFromStorage =
            this._storageUtilsService.getAppContext() ??
            AppContextModel.globalContext;
        if (appContextFromStorage) {
            this._store.dispatch(
                setAppContext({ appContext: appContextFromStorage }),
            );
        }
    }
    /** language changes listener */
    languagesChangeListener(): void {
        this._languagesService.currentLanguage$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((activeLang) => {
                this.setDirectionRtlOrLtr(activeLang);
            });
    }

    /**
     * Change direction rtl <=> ltr based on active language
     * @param activeLanguage - The active language code
     */
    setDirectionRtlOrLtr(activeLanguage: string): void {
        const direction = activeLanguage === "dz" ? "rtl" : "ltr";

        this.renderer.setAttribute(this.document.documentElement, "dir", direction);

        this.updateBodyDirectionClass({ direction });
    }

    private updateBodyDirectionClass({
        direction,
    }: {
        direction: "rtl" | "ltr";
    }): void {
        const bodyClass =
            direction === "rtl"
                ? Constants.rtlDirectionClass
                : Constants.ltrDirectionClass;

        if (this.document.body.classList.contains(Constants.rtlDirectionClass)) {
            this.renderer.removeClass(
                this.document.body,
                Constants.rtlDirectionClass,
            );
        }

        if (this.document.body.classList.contains(Constants.ltrDirectionClass)) {
            this.renderer.removeClass(
                this.document.body,
                Constants.ltrDirectionClass,
            );
        }

        this.renderer.addClass(this.document.body, bodyClass);
    }
}


